import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, ShieldCheck, Zap, CreditCard, MapPin } from 'lucide-react';
export function ClosingSection() {
  return <section className="bg-[#0A0A0A] py-14 px-4 text-white" data-id="element-69">
      <div className="container mx-auto max-w-4xl" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-8" data-id="element-71">
          <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight" data-id="element-72">
            La decisión más fácil que vas a tomar hoy
          </h2>

          <div className="text-left max-w-2xl mx-auto space-y-4 mb-10 text-lg text-gray-300" data-id="element-73">
            <p className="flex items-start gap-3" data-id="element-74">
              <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-75" />
              <span data-id="element-76">
                Podés seguir calculando a ojo y cruzando los dedos para que el
                presupuesto cierre.
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-77">
              <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-78" />
              <span data-id="element-79">
                Podés seguir perdiendo clientes porque tardás 3 días en pasarles
                el precio.
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-80">
              <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-81" />
              <span data-id="element-82">
                Podés seguir quemando perfiles por errores de descuento.
              </span>
            </p>
          </div>

          <p className="text-xl md:text-2xl font-bold text-[#D4A017] max-w-3xl mx-auto italic" data-id="element-83">
            "Un solo perfil de línea A30 quemado te cuesta más que todo este
            sistema. La matemática es simple."
          </p>
        </motion.div>

        {/* Comparison Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} className="bg-[#111111] rounded-2xl overflow-hidden border border-gray-800 mb-10" data-id="element-84">
          <div className="grid grid-cols-2 bg-black/50 p-4 border-b border-gray-800" data-id="element-85">
            <div className="text-center font-bold text-gray-400" data-id="element-86">
              Sin sistema
            </div>
            <div className="text-center font-bold text-[#D4A017]" data-id="element-87">
              Con Super Combo
            </div>
          </div>

          {[{
          bad: 'Calculás a ojo',
          good: 'Tabla exacta'
        }, {
          bad: 'Perdés perfiles',
          good: 'Cero desperdicio'
        }, {
          bad: 'Cliente en visto',
          good: 'Scripts que cierran'
        }, {
          bad: 'Margen 10%',
          good: 'Margen 35-40%'
        }, {
          bad: 'Trabajás de noche',
          good: 'Sistema en 20 min'
        }].map((row, i) => <div key={i} className="grid grid-cols-2 p-4 border-b border-gray-800/50 last:border-0" data-id="element-88">
              <div className="flex items-center justify-center gap-2 text-gray-400" data-id="element-89">
                <X className="w-4 h-4 text-red-500" data-id="element-90" /> {row.bad}
              </div>
              <div className="flex items-center justify-center gap-2 text-white font-medium" data-id="element-91">
                <Check className="w-4 h-4 text-green-500" data-id="element-92" /> {row.good}
              </div>
            </div>)}
        </motion.div>
      </div>

      <footer className="text-center text-gray-600 text-sm mt-24 pb-8" data-id="element-93">
        <p data-id="element-94">
          © 2026 Super Combo Carpintería en Aluminio — Todos los derechos
          reservados
        </p>
      </footer>
    </section>;
}